import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { MatDialogConfig, MatDialogRef, MatDialog } from '@angular/material';
import { Subject, Observable } from 'rxjs';
import { AlertMessageComponent } from 'src/app/modules/shared/components/alert-message/alert-message.component';

@Component({
  selector: 'ark-patient-camera',
  templateUrl: './patient-camera.component.html',
  styleUrls: ['./patient-camera.component.scss']
})
export class PatientCameraComponent implements OnInit {

  @ViewChild('file') file: any;  
  @Output() uploadImage = new EventEmitter<any>();
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  dialogConfig = new MatDialogConfig();
  public errors: WebcamInitError[] = [];

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();
  constructor(
    public dialogRef: MatDialogRef<PatientCameraComponent>,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
      this.dialogConfig.disableClose = true;
      this.dialogConfig.backdropClass = 'mat-dialog-backdrop';
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.dialogConfig.data = {
      title: 'Sorry!',
      message: error.message,
      button: 'Okay',
      event: this.close
    };
    let dialogRef = this.dialog.open(AlertMessageComponent, this.dialogConfig);
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean|string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.pictureTaken.emit(webcamImage);
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  onFileChanged(event) {
    const selectedFile = event.target.files[0]
    this.uploadImage.emit(selectedFile);
  }

  close() {
    this.dialogRef.close();
  }
}
